const upcomingData = [
    {
        name: 'Upcoming 1',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/8N0i7XE3ldo.jpg'
    },
    {
        name: 'Upcoming 2',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/oTjL3P76Bf9.jpg'
    },
    {
        name: 'Upcoming 3',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/7aWTSm4uKLU.jpg'
    },
    {
        name: 'Upcoming 4',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/eoDU2nTrkk1.jpg'
    },
    {
        name: 'Upcoming 5',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/vr7B9B4mA95.jpg'
    },
    {
        name: 'Upcoming 6',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/jQA2HO2Rirr.jpg'
    },
    {
        name: 'Upcoming 7',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/Kd1owAEqWSB.jpg'
    },
    {
        name: 'Upcoming 8',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/W518A3z1Ne1.jpg'
    },
    {
        name: 'Upcoming 9',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/2Z2ghRFmDNS.jpg'
    },
    {
        name: 'Upcoming 10',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/bsvbG9OzO2T.jpg'
    },
    {
        name: 'Upcoming 11',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Upcoming 12',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/4763O8V75pf.jpg'
    },
    {
        name: 'Upcoming 13',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Upcoming 14',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Upcoming 15',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/QW1KCCz8RWN.jpg'
    },
    {
        name: 'Upcoming 16',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    }
]

export default upcomingData;